import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CreateDesignatedUnitModalService } from './services/create-designated-unit-modal.service';
import { EmployerPlanDesignatedUnit } from '../../../../../../models/employers/plans/employer-plan-designated-unit';

@Component({
  selector: 'app-create-designated-unit-modal',
  templateUrl: './create-designated-unit-modal.component.html',
  styleUrls: ['./create-designated-unit-modal.component.scss'],
  providers: [CreateDesignatedUnitModalService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateDesignatedUnitModalComponent {
  private modalService = inject(CreateDesignatedUnitModalService);

  public currentStepComponent$ = this.modalService.currentStepComponent$;

  public setExistingDesignatedUnits(units: EmployerPlanDesignatedUnit[]): void {
    this.modalService.setExistingDesignatedUnits(units);
  }

  public setEmployerPlanId(id: number): void {
    this.modalService.setEmployerPlanId(id);
  }
}
